import React, { Component, useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { BrandSelector } from "../appSettings/brandSelector/brandSelector.component";
import { AppSettingsActions } from "../appSettings/redux/appSettings.reducer";

import { UserContextActions } from "./redux/userContext.reducer";

const OneBrandComponent = ({ action, brands }) => {
  const currentBrand = brands.length ? brands[0].id : 1;

  useEffect(() => {
    action(currentBrand);
  }, [action, currentBrand]);

  return <div />;
}

class CommonUserActions extends Component {
  render() {
    const { state, brand, selectBrand } = this.props;

    return (
      <>
        {state.loggedIn && !brand && (
          state.data.user.brands.length <= 1 ? (
            <OneBrandComponent action={selectBrand} brands={state.data.user.brands} />
          ) : (
            <BrandSelector brands={state.data.user.brands.length} />
          )
        )}
      </>
    );
  }
}
const mapStateToProps = state => ({ state: state.userContext, brand: state.appSettings.currentBrand });

const mapDispatchToProps = dispatch => ({
  selectBrand: (id) => dispatch(AppSettingsActions.selectBrand(id)),
});

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonUserActions));
